import { SSO_SIGN_IN, USER_LOGIN, SSO_SIGN_OUT, IS_AUTHENTICATED, UPDATE_SSO_USER_SCHOOLCODE } from "../actions/types";
const INITIAL_STATE = {
  isSignedIn: null,
  ssoUser: null,
  user: null,
  role: null
};

 // eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SSO_SIGN_IN:
      return {
        ...state,
        isSignedIn: true,
        ssoUser: action.payload.profile
      };
    case UPDATE_SSO_USER_SCHOOLCODE:
      return {
        ...state,
        ssoUser: {...state.ssoUser, schoolCode: action.payload}
      }
    case USER_LOGIN:
      return {
        ...state,
        isSignedIn: true,
        user: action.payload
      };
    case SSO_SIGN_OUT:
      return {
        ...action.payload
      };
    case IS_AUTHENTICATED:
      return{
        ...state,
        role: action.payload
      }
    default:
      return state;
  }
};
